import React from "react"
import { Row } from "reactstrap"
import BlockedStepsForWp from "./blockedStepsForWp"

const AuthorisedSignatory = ({ kycData, currentStep, querySteps = [] }) => {
  return (
    <>
      <Row>
        <div className="bank-details-wrapper">
          <h5 className="title">Authorised Person KYC</h5>
          <BlockedStepsForWp
            kycData={kycData}
            currentStep={currentStep}
            querySteps={querySteps}
          />
        </div>
      </Row>
    </>
  )
}

export default AuthorisedSignatory
